export default __webpack_public_path__ + "static/media/star_power.38fa33d7.png";